module.exports = __webpack_public_path__ + "static/media/map-marker.c5d70af8.svg";